import * as React from 'react';

import { Tag } from 'antd';

export const ImplementationFeeWaived = () => (
  <Tag className="implementaion-fee-waived-tag">Implementation Fee Waived</Tag>
);
